import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShield, faFileContract } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start">
            &copy; {year} Nodesail. Old Satkhira Road, Khulna, KH 9253, Bangladesh
          </div>
          <div className="col-md-6 text-center text-md-end footer-links">
            <a href="https://nodesail.com/privacy" className="footer-link privacy-link" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faShield} className="me-2" />
              Privacy
            </a>
            <a href="https://nodesail.com/terms" className="footer-link terms-link" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFileContract} className="me-2" />
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;